<template>
  <section>
    <validation-observer
      ref="observer"
      v-slot="{ invalid }"
      tag="div"
    >
      <form @submit.prevent="submit">
        <div class="support-form">
          <input-form
            id="subject"
            ref="subject"
            v-model="subject"
            :title="$t('question.subject')"
            name="subject"
            :placeholder="$t('question.subjectPlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            maxlength="50"
          />
          <input-form
            id="name"
            ref="name"
            v-model="name"
            :title="$t('question.name')"
            name="name"
            :placeholder="$t('question.namePlaceholder')"
            type="text"
            autocomplete="off"
            required="required"
            maxlength="50"
          />
          <input-form
            id="mail"
            ref="mail"
            v-model="mail"
            :title="$t('question.email')"
            name="mail"
            :placeholder="$t('question.emailPlaceholder')"
            type="email"
            autocomplete="off"
            required="required"
            maxlength="50"
          />
          <input-form
            id="textarea"
            ref="textarea"
            v-model="textarea"
            :title="$t('question.detail')"
            name="textarea"
            :placeholder="$t('question.detailPlaceholder')"
            type="textarea"
            autocomplete="off"
            required="required"
            maxlength="500"
          />
          <input-form
            id="file"
            v-model="file"
            :title="$t('question.attachFile')"
            :placeholder="$t('question.attachFilePlaceholder')"
            type="file"
            :is-upload="attachFileId !== null"
            :loading="fileLoading"
            :error-message="fileError"
            @input="attachUpload"
            @change:delete="onDeleteFile"
          >
            <small>{{ $t('question.attachFileNote') }}</small>
          </input-form>
        </div>

        <div class="support-agree">
          <!--          <div class="agree-check-all">-->
          <!--            <check-box-->
          <!--              id="all"-->
          <!--              v-model="agreeAll"-->
          <!--              text="전체 동의합니다."-->
          <!--              name="agree-all"-->
          <!--              @input="onChangeAgreeAll($event)"-->
          <!--            />-->
          <!--          </div>-->

          <div class="agree-wrap">
            <div class="agree-title">{{ $t('question.privateTitle') }}</div>
            <div class="agree-content">
              <div class="agree-check">
                <check-box
                  id="private"
                  ref="private"
                  v-model="agreePrivate"
                  :text="$t('question.private')"
                  name="agree-private"
                  required="required"
                />
              </div>
              <html-view class="agree-term" :value="$t('question.privateValue')" />
              <!--              <div class="agree-term">-->
              <!--                <p>(주)우아한형제들은 제휴·문의사항 등록 시, 최소한의 범위 내에서 아래와 같이 개인정보를 수집·이용합니다.</p>-->
              <!--                <ol>-->
              <!--                  <li>-->
              <!--                    1. 수집하는 개인정보 항목-->
              <!--                    <table class="agree-term-table">-->
              <!--                      <thead>-->
              <!--                        <tr>-->
              <!--                          <th>구분</th>-->
              <!--                          <th>수집하는 개인정보 항목</th>-->
              <!--                          <th>수집 및 이용 목적</th>-->
              <!--                        </tr>-->
              <!--                      </thead>-->
              <!--                      <tbody>-->
              <!--                        <tr>-->
              <!--                          <td>제휴, 제안</td>-->
              <!--                          <td>소속, 이름, 전자우편주소</td>-->
              <!--                          <td>제휴, 제안 접수 및 처리결과 회신</td>-->
              <!--                        </tr>-->
              <!--                        <tr>-->
              <!--                          <td>언론홍보문의</td>-->
              <!--                          <td>매체명, 이름, 전자우편주소</td>-->
              <!--                          <td>언론홍보문의 접수 및 처리결과 회신</td>-->
              <!--                        </tr>-->
              <!--                        <tr>-->
              <!--                          <td>지원문의</td>-->
              <!--                          <td>이름, 전자우편주소</td>-->
              <!--                          <td>지원문의 접수 및 처리결과 회신</td>-->
              <!--                        </tr>-->
              <!--                        <tr>-->
              <!--                          <td>광고신청문의</td>-->
              <!--                          <td>이름, 업소명, 업소주소, 연락처, 전자우편주소</td>-->
              <!--                          <td>광고신청문의 접수 및 처리결과 회신</td>-->
              <!--                        </tr>-->
              <!--                        <tr>-->
              <!--                          <td>기타문의</td>-->
              <!--                          <td>이름, 전자우편주소</td>-->
              <!--                          <td>기타문의 접수 및 처리결과 회신</td>-->
              <!--                        </tr>-->
              <!--                      </tbody>-->
              <!--                    </table>-->
              <!--                  </li>-->
              <!--                  <li>2. 수집 및 이용 목적: 제휴·문의사항 접수 및 처리결과 회신</li>-->
              <!--                  <li>3. 개인정보의 이용기간: <span class="underline">목적 달성 후, 해당 개인정보를 지체없이 파기</span></li>-->
              <!--                </ol>-->
              <!--                <p>위 개인정보 수집‧이용에 대한 동의를 거부할 권리가 있습니다. 다만 동의를 거부하는 경우 제휴·문의사항 등록이 제한될 수 있습니다.</p>-->
              <!--              </div>-->
            </div>
          </div>
        </div>

        <div class="support-btn">
          <button type="submit" class="btn btn-fill btn-wide" :disabled="invalid">{{ $t('question.submit') }}</button>
        </div>
      </form>
    </validation-observer>
  </section>
</template>
<script>
import supportForm from '@/mixins/supportForm'

export default {
  mixins: [supportForm],
  watch: {
    agreePrivate (v) {
      this.agreeAll = v
    }
  },
  methods: {
    submit () {
      this.saveQuestion({
        title: this.subject,
        name: this.name,
        email: this.mail,
        content: this.textarea,
        type: 'ETC'
      })
    },
    onChangeAgreeAll (v) {
      if (v) {
        this.agreePrivate = true
        this.agreePrecautions = true
      } else {
        this.agreePrivate = false
        this.agreePrecautions = false
      }
    }
  }
}
</script>
